import { stringToSelectOption } from '@shared/select/select.utils';

export const fieldOptionsToSelectOptions = options => options
    .map(({ name }) => stringToSelectOption(name));

export const enumToSelectOptions = options => Object
    .values(options)
    .map(stringToSelectOption);
